export const mobileBtnSize = 40
export const webBtnSize = 30
export const widgetPadding = 13
